import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ze-access-required-view',
  templateUrl: './access-required-view.component.html',
  styleUrls: ['./access-required-view.component.scss']
})
export class AccessRequiredViewComponent {
  constructor(private router: Router) {}

  goBack() {
    // Navigate to project page (safe fallback — no login flash)
    const projectId = localStorage.getItem('projectId');
    if (projectId) {
      this.router.navigate(['/library']);
    } else {
      this.router.navigate(['/project']);
    }
  }
}
